<template>
  <div class="chatHeader">
    <div class="chatUser">
      <el-upload
        class="avatar-uploader"
        :action="uploadUrl"
        accept=".jpg,.png"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
      >
        <div
          v-if="user.avatarFileUrl || defaultImgUrl"
          class="avatar"
          :style="
            'background-image: url(\'' +
            (user.avatarFileUrl || defaultImgUrl) +
            '\');'
          "
        ></div>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        <!-- <img :src="user.avatarFileUrl || defaultImgUrl" v-if="user.avatarFileUrl || defaultImgUrl" class="avatar" alt=""> -->
        <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
      </el-upload>
      <!-- <el-avatar class="avatar" :size="55" src="../../../../../assets/chatImg/user-4.png"></el-avatar> -->
      <div class="userName">
        <div class="nameAndVip">
          <p>{{ user.userName }}</p>
          <!-- <img class="vipIcon" src="../../../../../assets/img/info/会员V2.svg" alt=""> -->
        </div>
        <el-upload
          class="avatarBtn"
          :action="uploadUrl"
          accept=".jpg,.png"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
        >
          <el-button type="text" class="avatarBtn">设置头像</el-button>
        </el-upload>
      </div>
    </div>
    <div class="actions">
      <!-- <div class="action" v-for="(item,index) in actionList" :key="item.icon" @click="changeComponentName(item.componentName)">
        <i :class="item.icon"></i>
        <span class="unread" v-if="item.unread"></span>
      </div> -->
      <div :class="['action', comname === 'Settings' ? 'chooseAction' : '']" @click="changeComponentName('Settings')">
        <i class="ti-settings"></i>
      </div>
      <div v-if="user.promoCode" :class="['action', comname === 'Agent' ? 'chooseAction' : '']" @click="changeComponentName('Agent')">
        <i class="ti-user"></i>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {mapState, mapMutations} from 'vuex';

export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      uploadUrl: api.uploadUrl,
      updateUserByClient: api.updateUserByClient,
      getUserInfo: api.getUserInfo,
      defaultImgUrl: require("@/assets/img/default_avatar.png"),
      showUser: {},
      actionList: [
        {
          icon: 'ti-settings',
          unread: false,
          componentName: 'Settings',
        },
        {
          icon: 'ti-user',
          unread: false,
          componentName: 'Agent',
        },
        // {
        //   icon: 'ti-bell',
        //   unread: true,
        //   componentName: 'Notification',
        // },
      ],
    }
  },
  computed: {
    ...mapState('comAbout', {comname: 'componentName'}),
    ...mapState('userAbout', ['user']),
  },
  watch: {
  },
  created () {},
  mounted () {
    console.log('user', this.user);
    this.showUser = { ...this.user };
    // this.getLatelyUserInfo();
  },
  methods: {
    ...mapMutations('comAbout', ['changeComponentName']),
    ...mapMutations('userAbout', ['setUser']),
    chakan(){
    },
    //上传头像
    async handleAvatarSuccess(res) {
      var id = res.data;
      if (id) {
        // this.user.avatarFile = id;
        this.showUser.avatarFile = id;
        this.toUpdateUserByClient();
      }
    },
    //更新用户信息
    toUpdateUserByClient(callback) {
      // this.loading = true;
      var param = {
        userName: this.user.userName,
        account: this.user.account,
        avatarFile: this.showUser.avatarFile,
      };
      this.updateUserByClient(param)
        .then((res) => {
          if (res.success) {
            callback && callback(true);
            this.getLatelyUserInfo();
          } else {
            callback && callback(false);
            this.$message.error(res.message);
          }
          // this.loading = false;
        })
        .catch((e) => {
          callback && callback(false);
          // this.loading = false;
        });
    },
    //获取最新用户信息
    getLatelyUserInfo() {
      // this.loading = true;
      this.getUserInfo()
        .then((res) => {
          if (res.data != null) {
            // this.user = res.data;
            // 更新数据库
            this.setUser(res.data);
            this.showUser = res.data;
          }
          // this.loading = false;
        })
        .catch((e) => {
          // this.loading = false;
        });
    },
  }
}
</script>

<style scoped lang="less">
.chatHeader {
  padding: 30px 30px 0;
  display: flex;
  justify-content: space-between;

  .chatUser {
    display: flex;
    .avatar-uploader {
      display: inline-block;
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-size: cover;
      background-position: center;
      margin-right: 16px;
    }
    .avatar {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
    .avatar-uploader-icon {
      width: 55px;
      font-size: 28px;
      color: #999;
      line-height: 55px;
      text-align: center;
      border: 1px dashed #d9d9d9;
      border-radius: 50%;
      cursor: pointer;
    }
    // .avatar {
    //   margin-right: 16px;
    // }
    .userName {
      .nameAndVip {
        display: flex;
        margin-top: 8px;
        p {
          font-size: 15px;
          font-weight: 600;
          line-height: 1.5;
          margin-right: 8px;
        }
        .vipIcon {
          width: 15px;
          height: 22px;
        }
      }

      .avatarBtn {
        padding: 0;
      }
    }
  }

  .actions {
    display: flex;
    .action {
      position: relative;
      margin-left: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 22px;
        color: #aaa;
      }
      i:hover {
        color: #2f80ec;
      }
      .unread {
        background: #ffc107;
        width: 7px;
        height: 7px;
        position: absolute;
        border-radius: 50%;
        top: 14px;
        right: -3px;
      }
    }
    .chooseAction {
      i {
        color: #2f80ec;
      }
    }
  }
}
</style>
